"use strict";
const config = require('../../../../../config/locales_json/packs/private/admin/wizard_form_client.json');
const language = $('body').data("language");

// Class definition
var KTWizardClient = function () {
	// Base elements
	var _wizardEl;
	//var _formEl;
	var _wizard;
	//var _validations = [];

	// Private functions
	var initWizard = function () {
		var isNew = $(".new-client-container").length > 0 ? true : false

		// Initialize form wizard
		_wizard = new KTWizard(_wizardEl, {
			startStep: 1, // initial active step number
			clickableSteps: (isNew ? false : true) // to make steps clickable this set value true and add data-wizard-clickable="true" in HTML for class="wizard" element
		});

		// Validation before going to next page
		_wizard.on('beforeNext', function (wizard) {
			// Don't go to the next step yet
			_wizard.stop();

			//render_review_form()
			//_wizard.goNext();

			var actualStep = $(wizard)[0]["currentStep"]
			// Formulario de crear cliente
			if(actualStep == 1){
				//_wizard.goNext();
				// Obtenemos el valor del campo client
				const selectedClientID = $("#client-form #client_client_id").val();
				// Si el campo es un numero significa que es un cliente del selector
				if(isValidNumber(selectedClientID)){
					// Validamos que el cliente no exista en FJ para poder seguir avanzando			
					checkIfExistsFJClient(selectedClientID)
				// De lo contrario es un cliente nuevo
				} else {
					var formOfert = check_inputs_form("client-step-1");

					if(!formOfert){
						const errorText = getTranslationValue(config, [language, "KTWizardClient", "initWizard", "formOfert_error_text"], "Lo sentimos!, hemos detectado algunos errores. Por favor revise los datos ingresados.");
						error_alert(errorText)
					} else {
						render_review_form()
						_wizard.goNext();
					}
				}

			// Asignación de areas
			} else if(actualStep == 2){
				//_wizard.goNext();

				// Revisa si ha sido checkeado algun elemento
				var isChecked = $('#client-step-2 .category-client-item:checked').length;
				// Si no esta chequeado
				if (isChecked == 0) {
					const errorText = getTranslationValue(config, [language, "KTWizardClient", "initWizard", "actualStep_2_error_text"], "Debes seleccionar al menos una opción.");
					error_alert(errorText)
				} else {
					render_review_form()
					_wizard.goNext();
				}
			} else if(actualStep == 3){

				// Se validan los campos
				var formClientProfile = check_inputs_form("client-step-3");

				if(!formClientProfile){
					const errorText = getTranslationValue(config, [language, "KTWizardClient", "initWizard", "formOfert_error_text"], "Lo sentimos!, hemos detectado algunos errores. Por favor revise los datos ingresados.");
					error_alert(errorText)
				} else {
					render_review_form()
					_wizard.goNext();
				}
			}
		});

		// Change event
		_wizard.on('change', function (wizard) {
			KTUtil.scrollTop();
		});
	}

	var check_inputs_form = function (form) {
		var error = 0;
		var container = $('#'+form+'');
		var inputs = container.find($("input").not(".optional"));
		var selects = container.find($("select").not(".optional"));
		var textareas = container.find($("textarea").not(".optional"));

		const errorMsgText = getTranslationValue(config, [language, "KTWizardClient", "check_inputs_form", "errorMsgText"], "Debes completar este campo.");
		const errorWithoutOptionsText = getTranslationValue(config, [language, "KTWizardClient", "check_inputs_form", "errorWithoutOptionsText"], "Debes agregar al menos una opción.");

		var errorMsg = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorMsgText+'</div></div>';
		var errorWithoutOptions = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorWithoutOptionsText+'</div></div>';

		inputs.each(function() {
			var inputName = $(this).attr('name');
			var inputType = $(this).attr('type');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "" && typeof inputName != "undefined") {
				if (inputType == "radio" || inputType == "checkbox") {
					inputName = $(this).attr('name');
					// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
					contInput = $(this).parent().parent();
					// Validamos si este input esta dentro de un checkbox list
					if(contInput.hasClass("checkbox-list")){
						// Cambia el contInput
						contInput = $(this).parent().parent().parent();
					}

					// Se busca el mensaje de error y lo elimina
					contInput.find(".fv-plugins-message-container").remove()
					// Revisa si esta activada la opcion
					var isChecked = $('input[name="'+ inputName +'"]:checked').length;
					// Si no esta chequeado
					if (isChecked == 0) {
						// Se muestra el mensaje de error
						contInput.append(errorMsg);
						// Le suma al contador de errores
						error++;
					} else {
						contInput.find(".fv-plugins-message-container").remove()
					}
				} else if (inputType == "text" || inputType == "date" || inputType == "number" || inputType == "hidden") {
					// Si es un campo hidden obligatorio es porque es un typeahead
					if (inputType == "hidden") {
						// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
						contInput = $(this).parent().parent();
						// Remueve el icono de alerta o success del input
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-invalid");
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-valid");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-icon-container").find(".fv-plugins-message-container").remove()
						// Remueve la clase has-danger o has-success del contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Si el input esta vacio
						if (!$(this).val()) {
							// Agrega el icono al input
							contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").addClass("is-invalid");
							// Agrega la clase de has-danger al contenedor del input
							contInput.find(".fv-plugins-icon-container").addClass("has-danger");
							// Se muestra el mensaje de error
							contInput.find(".fv-plugins-icon-container").append(errorMsg);
							// Le suma al contador de errores
							error++;
						// Si el input esta correcto
						} else {
							// Agrega el icono al input
							contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").addClass("is-valid");
							// Agrega la clase de has-danger al contenedor del input
							contInput.find(".fv-plugins-icon-container").addClass("has-success");
						}
					// Si son inputs normales
					} else {
						// Remueve el icono de alerta o success del input
						$(this).removeClass("is-invalid");
						$(this).removeClass("is-valid");
						// Remueve la clase de has-danger y has-success al contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-message-container").remove()
						// Si el input esta vacio
						if (!$(this).val()) {
							// Agrega el icono al input
							$(this).addClass("is-invalid");
							// Agrega la clase de has-danger al contenedor del input
							contInput.addClass("has-danger");
							// Se muestra el mensaje de error
							contInput.append(errorMsg);
							// Le suma al contador de errores
							error++;
						} else {
							// Agrega el icono al input
							$(this).addClass("is-valid");
							// Agrega la clase de has-success al contenedor del input
							contInput.addClass("has-success");
						}
					}

				} else if (inputType == "file") {
					// Remueve el icono de alerta o success del input
					$(this).removeClass("is-invalid");
					$(this).removeClass("is-valid");
					// Cambia el contInput
					contInput = $(this).parent().parent().parent();
					// Remueve la clase de has-danger y has-success al contenedor del input
					contInput.removeClass("has-danger");
					contInput.removeClass("has-success");
					// Se busca el mensaje de error y lo elimina
					contInput.find(".fv-plugins-message-container").remove()
					// Si el input esta vacio
					if (!$(this).val()) {
						// Agrega el icono al input
						$(this).addClass("is-invalid");
						// Agrega la clase de has-danger al contenedor del input
						contInput.addClass("has-danger");
						// Se muestra el mensaje de error
						contInput.append(errorMsg);
						// Le suma al contador de errores
						error++;
					} else {
						// Agrega el icono al input
						$(this).addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.addClass("has-success");
					}
				}
			}
		})

		selects.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Revisamos si el select es multiple
				var hasMultiple = $(this).attr("multiple")
				// Revisamos si el select es selectized
				var hasSelectized = $(this).hasClass("selectized")
				// Si el input esta vacio
				if ($(this).val().length == 0) {
					// Si es multiple
					if(hasMultiple) {
						// Al input con la clase tt-input le va a agregar la clase form-control para que muestre
						// el icono
						$(this).parent().find(".tt-input").addClass("form-control");
						// Cambia el icono de invalido por valido
						$(this).parent().find(".tt-input").removeClass("is-valid").addClass("is-invalid");
					}

					// Si es selectized
					if(hasSelectized) {
						// Al div con la clase selectize-control le va a agregar la clase is-invalid para que
						// cambie el icono de valido por invalido
						$(this).parent().find(".selectize-control").removeClass("is-valid").addClass("is-invalid");
					}

					$(this).addClass("is-invalid");
					contInput.addClass("has-danger");
					contInput.append(errorMsg);
					error++;
				} else {
					// Debemos validar el formulario de preguntas para las preguntas con opciones.
					// Asi que primero detectamos que select es una preguna del formulario
					var hasQuestionSelect = $(this).hasClass("filter_question_enum_type")
					// Si es un select del formulario de preguntas
					if(hasQuestionSelect) {
						// Si la pregunta es de los tipo con opciones
						if ($(this).val() == "2" || $(this).val() == "3" || $(this).val() == "4") {
							// Obtiene las opciones que hay
							var optionsQuestion = $(this).parent().parent().parent().find(".cont-option-question-filter").children()
							// Si hay opciones se valida correctamente
							if(optionsQuestion.length > 0){
								// Agrega el icono al input
								$(this).addClass("is-valid");
								// Agrega la clase de has-success al contenedor del input
								contInput.addClass("has-success");
							// Si no tiene opciones
							} else {
								$(this).addClass("is-invalid");
								contInput.addClass("has-danger");
								contInput.append(errorWithoutOptions);
								error++;
							}
						// Si la pregunta es de un tipo texto
						} else {
							// Agrega el icono al input
							$(this).addClass("is-valid");
							// Agrega la clase de has-success al contenedor del input
							contInput.addClass("has-success");
						}

					// De lo contrario es un select normal y se valida correctamente
					} else {
						// Si es multiple
						if(hasMultiple) {
							// Cambia el icono de invalido por valido
							$(this).parent().find(".tt-input").removeClass("is-invalid").addClass("is-valid");
						}

						// Si es selectized
						if(hasSelectized) {
							// Al div con la clase selectize-control le va a agregar la clase is-invalid para que
							// cambie el icono de valido por invalido
							$(this).parent().find(".selectize-control").removeClass("is-invalid").addClass("is-valid");
						}

						// Agrega el icono al input
						$(this).removeClass("is-invalid").addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.addClass("has-success");
					}
				}
			}
		})

		textareas.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Si el input esta vacio
				if (!$(this).val()) {
					// Agrega el icono al input
					$(this).addClass("is-invalid");
					// Agrega la clase de has-danger al contenedor del input
					contInput.addClass("has-danger");
					// Muestra el mensaje de error
					contInput.append(errorMsg);
					error++;
				} else {
					// Agrega el icono al input
					$(this).addClass("is-valid");
					// Agrega la clase de has-success al contenedor del input
					contInput.addClass("has-success");
				}
			}
		})

		// Se coloca el simbolo de ok a los campos que no son obligatorios
		var inputsNotOptional = container.find($("input.optional"));
		var selectsNotOptional = container.find($("select.optional"));
		var textareasNotOptional = container.find($("textarea.optional"));

		inputsNotOptional.each(function() {
			var inputName = $(this).attr('name');
			var inputType = $(this).attr('type');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				if (inputType == "text" || inputType == "date" || inputType == "number" || inputType == "hidden") {
					// Si es un campo hidden obligatorio es porque es un typeahead
					if (inputType == "hidden") {
						// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
						contInput = $(this).parent().parent();
						// Remueve el icono de alerta o success del input
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-invalid");
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-valid");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-icon-container").find(".fv-plugins-message-container").remove()
						// Remueve la clase has-danger o has-success del contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Agrega el icono al input
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.find(".fv-plugins-icon-container").addClass("has-success");
					// Si son inputs normales
					} else {
						// Remueve el icono de alerta o success del input
						$(this).removeClass("is-invalid");
						$(this).removeClass("is-valid");
						// Remueve la clase de has-danger y has-success al contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-message-container").remove()
						// Agrega el icono al input
						$(this).addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.addClass("has-success");
					}
				} else if (inputType == "checkbox") {
					// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
					contInput = $(this).parent().parent();
					// Se busca el mensaje de error y lo elimina
					contInput.find(".fv-plugins-message-container").remove()
				}
			}
		})

		selectsNotOptional.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				// Revisamos si el select es multiple
				var hasMultiple = $(this).attr("multiple")
				// Revisamos si el select es selectized
				var hasSelectized = $(this).hasClass("selectized")
				// Si es multiple
				if(hasMultiple) {
					// Cambia el icono de invalido por valido
					$(this).parent().find(".tt-input").removeClass("is-invalid").removeClass("is-valid").addClass("is-valid");
				}
				// Si es selectized
				if(hasSelectized) {
					// Al div con la clase selectize-control le va a agregar la clase is-invalid para que
					// cambie el icono de valido por invalido
					$(this).parent().find(".selectize-control").removeClass("is-invalid").removeClass("is-valid").addClass("is-valid");
				}

				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Agrega el icono al input
				$(this).addClass("is-valid");
				// Agrega la clase de has-success al contenedor del input
				contInput.addClass("has-success");
			}
		})

		textareasNotOptional.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Agrega el icono al input
				$(this).addClass("is-valid");
				// Agrega la clase de has-success al contenedor del input
				contInput.addClass("has-success");
			}
		})

		return error == 0 ? true : false;
	}

	var render_review_form = function() {
		// Esto es del primer paso del wizard
		// Asigna la infromacion a las variables
		var logo = $("#client-form #cont_form_client_logo .image-input-wrapper").attr("style")
		var company = $("#client-form #client_company option:selected").text()
		var clientName = $("#client-form #client_client_id option:selected").text()
		var anonymousName = $("#client-form #client_anonymous_name").val()
		var publicName = $("#client-form #client_name").val()
		var country = $("#client-form #client_country option:selected").text()
		var website = $("#client-form #client_website").val()

		var banner = $("#client-form #cont_form_client_profile_banner .image-input-wrapper").attr("style")
		var nCollaborators = $("#client-form #cp_overview_collaborators").val()
		var location = $("#client-form #cp_overview_location").val()
		var aboutHTML = $("#client-form #cp_about_us").val()
		var about = aboutHTML ? aboutHTML.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim() : "-";
		var ranking = $("#client-form #client_profile_ranking_input").is(':checked') ? true : false;
		var profileVideo = $("#client-form #client_profile_video").val()

		// Reemplaza la información que existan en los elementos por el de la variable
		$("#client-form #item_logo .image-input-wrapper").attr("style", logo)
		$("#client-form #item_company span").text(company)
		$("#client-form #item_name span").text(clientName)
		$("#client-form #item_public_name span").text(publicName)
		$("#client-form #item_anonymous_name span").text(anonymousName)
		$("#client-form #item_country span").text(country)
		$("#client-form #item_website span").text(website)
		$("#client-form #item_banner .image-input-wrapper").attr("style", banner)
		$("#client-form #item_collaborators span").text(nCollaborators == "" ? "-" : nCollaborators)
		$("#client-form #item_location span").text(location== "" ? "-" : location)
		$("#client-form #item_about span").text(about== "" ? "-" : about)
		$("#client-form #item_ranking span").text(ranking? "Si" : "No")
		if (profileVideo) $("#client-form #item_profile_video span").text(profileVideo)

		// Se limpia el listado de areas
		$("#client-form .cont-category-clients").html('');
		// Revisa si ha sido checkeado algun elemento
		var categorySelected = $('#client-step-2 .category-client-item:checked');
		if (categorySelected.length > 0) {
			var listClientCategories = ""
			$.each(categorySelected, function(i, category) {
				// Se obtiene el texto del label
				var categoryName = $(category).parent().text()
				// Se limpian los espacios del string
				categoryName = $.trim(categoryName)
				// Se asigna el elemento a renderear
				var outputList = "<li>"+categoryName+"</li>";
				// Se agrega el nuevo elemento en el listado
				listClientCategories = listClientCategories + outputList
			});

			var output = '<div class="row container cont-review-options"><div class="col-sm-12"><ul class="mt-5">'+listClientCategories+'</ul></div></div></div>';

			$("#client-form .cont-category-clients").append(output)
		}

		// Preview Perfil Empresa
		if ($("#client-form #client-step-3").length > 0) {
			var bannerStyle = $("#client-form #cont_form_client_profile_banner .image-input-wrapper").attr("style")
			var showNCollaborators = $("#client-form #cp_overview_collaborators").parent().find(".overview-is-active").is(':checked')
			var showLocation = $("#client-form #cp_overview_location").parent().find(".overview-is-active").is(':checked')
			var aboutCompany = $.parseHTML($("#client-form #cp_about_us").val())

			$("#client-form #item_banner .image-input-wrapper").attr("style", bannerStyle);
			
			if (showNCollaborators) {
				$("#client-form #item_n_collaborators").removeClass("d-none");
				$("#client-form #item_n_collaborators span").text($("#client-form #cp_overview_collaborators").val())
			} else {
				$("#client-form #item_n_collaborators").addClass("d-none");
				$("#client-form #item_n_collaborators span").text("")
			}

			if (showLocation) {
				$("#client-form #item_overview_location").removeClass("d-none");
				$("#client-form #item_overview_location span").text($("#client-form #cp_overview_location").val())
			} else {
				$("#client-form #item_overview_location").addClass("d-none");
				$("#client-form #item_overview_location span").text("")
			}

			$("#client-form #item_about_us span").html(aboutCompany)

			if ($("#client_profile_ranking").length > 0 && !$("#client_profile_ranking").parent().hasClass('disabled')) {
				var showRanking = $("#client-form #client_profile_ranking_input").is(':checked');
				const showRankingTranslation = { "es": "Sí", "en": "Yes", "pt": "Sim" };
				
				if (showRanking) {
					$("#client-form #item_cp_ranking").removeClass("d-none")
					$("#client-form #item_cp_ranking span").text(showRankingTranslation[language])	
				} else {
					$("#client-form #item_cp_ranking").addClass("d-none")
					$("#client-form #item_cp_ranking span").text("")	
				}
			}
		}
	}

	var checkIfExistsFJClient = function (selectedClientID) {
		const AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
		// Es el id original del cliente que se edita (Solo aparece en el editar, para el crear se define con un 0)
		const originalClientID = ($("#client-form #client_client_id").data("id") || 0);

		// Consulta ajax
		$.ajax({
			type: "GET",
			url: "/admin/clients/check_if_exists",
			dataType: 'json',
			data: {
				original_id: originalClientID,
				client_id: selectedClientID,
				authenticity_token: AUTH_TOKEN
			}
		}).done(function(response, textStatus, jqXHR) {
			// Quita el cargando
			KTApp.unblockPage();

			// Si el cliente ya existe en la base de datos y los ids son diferentes muestra error
			if (response["exists"]) {
				$("#cont_company").addClass("disabled");
				
				Swal.fire({
					text: "El cliente ya existe en la base de datos de Firstjob, por favor selecciona otra opción.",
					icon: "error",
					buttonsStyling: false,
					confirmButtonText: getTranslationValue(config, [language, "topTable", "fail_Swalfire_confirmButtonText"], 'Aceptar'),
					customClass: {
							confirmButton: "btn btn-fj-purple"
					}
				});

			} else {
				var formOfert = check_inputs_form("client-step-1");

				if(!formOfert){
					const errorText = getTranslationValue(config, [language, "KTWizardClient", "initWizard", "formOfert_error_text"], "Lo sentimos!, hemos detectado algunos errores. Por favor revise los datos ingresados.");
					error_alert(errorText)
				} else {
					render_review_form()
					_wizard.goNext();
				}
			}
	
		}).fail(function(jqXHR, textStatus, errorThrown) {
			// Quita el cargando
			KTApp.unblockPage();
			// Muestra alerta indicando que hay un error
			Swal.fire({
					text: "Lo sentimos!, Hubo un problema y no se pudo obtener la información del cliente. Por favor inténtalo mas tarde.",
					icon: "error",
					buttonsStyling: false,
					confirmButtonText: getTranslationValue(config, [language, "topTable", "fail_Swalfire_confirmButtonText"], 'Aceptar'),
					customClass: {
							confirmButton: "btn btn-fj-purple"
					}
			});
		});
	}

	var error_alert = function(msg) {
		Swal.fire({
			text: msg,
			icon: "error",
			buttonsStyling: false,
			confirmButtonText: getTranslationValue(config, [language, "KTWizardClient", "error_alert", "swalfire_confirmButtonText"], "Aceptar"),
			customClass: {
				confirmButton: "btn btn-fj-purple"
			}
		}).then(function () {
			KTUtil.scrollTop();
		});
	}

	var isValidNumber = function (str) {
    return /^\d+$/.test(str) || (
			!isNaN(str) && 
      !isNaN(parseFloat(str)) && 
      str.toString() === parseFloat(str).toString()
  	);
	}

	return {
		// public functions
		init: function () {
			_wizardEl = KTUtil.getById('kt_wizard_client');
			//_formEl = KTUtil.getById('kt_form');

			// Se obtiene el campo kt_wizard_client
			var wizardClient = $('#kt_wizard_client')
			// Si existe el campo
			if (wizardClient.length > 0) {
				initWizard();
			}
		}
	};
}();

jQuery(document).ready(function () {
	KTWizardClient.init();

	/*************
	* CREAR / EDITAR CLIENTE
	*
	* - Logica de activacion de campo pais como autocompletar (typeahead)
	* - Validacion y ejecución del formulario
	*/

	// Se obtiene el campo client_country
	var clientCountry = $('#kt_wizard_client #client-form #client_country')
	// Si existe el campo
	if (clientCountry.length > 0) {
		// Se aplica selectize en el campo compañia
		clientCountry.selectize({
			create: false,
		});

		clientCountry.on("change", function(e){
			clearSelectize(clientName)
			clearSelectize(clientCompany)
			$("#client_name").val(null);
			$("#cont_company").addClass("disabled");

			var selfID = $(this).val()

			if(selfID == null || selfID == ""){
				return false
			}

			// Muestra un cargando
			KTApp.blockPage({
				overlayColor: '#000000',
				opacity: 0.4,
				state: 'primary',
				size: 'lg',
				message: '<p style="font-size: 16px; margin-bottom:0;">'+getTranslationValue(config, [language, "topTable", "KTApp_blockPage_message"], 'Buscando clientes...')+'</p>'
			});

			getCRMClientsByCountryID(selfID)
		});
	}

	// Se obtiene el campo client_name
	var clientName = $('#kt_wizard_client #client-form #client_client_id')
	// Inicializa el selectize en el campo client_name
	clientName.selectize({
		placeholder: 'Escribe el nombre del cliente',
		render: {
			option_create: function(query) {
				var listOptions = $("#cont_client_name .selectize-dropdown-content").find(".option")

				if(listOptions.length > 0){
					var classHidden = "hidden"
				} else {
					var classHidden = ""
				}

				return '<div class="create '+classHidden+'">Agregar <strong>'+query.input+'</strong>…</div>';
			}
		}
	});

	clientName.on("change", function(e){
		// Obtiene el valor del campo
		var selfID = $(this).val()
		// Obtiene el texto del label del campo
		var selfText = $(this).find("option:selected").text();

		if(selfID == null || selfID == ""){
			return false
		}

		$("#client_name").val(selfText);

		// Muestra un cargando
		KTApp.blockPage({
			overlayColor: '#000000',
			opacity: 0.4,
			state: 'primary',
			size: 'lg',
			message: '<p style="font-size: 16px; margin-bottom:0;">'+getTranslationValue(config, [language, "topTable", "KTApp_blockPage_message"], 'Buscando compañia...')+'</p>'
		});

		// Si es un numero
		if (isValidNumber(selfID)) {
			getCRMCompanyByClient(selfID)
		} else {
			getCRMCompanies()
		}
	});

	function isValidNumber(str) {
    return /^\d+$/.test(str) || (
			!isNaN(str) && 
      !isNaN(parseFloat(str)) && 
      str.toString() === parseFloat(str).toString()
  	);
	}

	// Se obtiene el campo client_name
	var clientCompany = $('#kt_wizard_client #client-form #client_company')
	// Se aplica selectize en el campo compañia
	clientCompany.selectize({
		create: true,
		placeholder: 'Escribe el nombre de la compañia',
		render: {
			option_create: function(query) {
				var listOptions = $("#cont_form_company_name .selectize-dropdown-content").find(".option")

				if(listOptions.length > 0){
					var classHidden = "hidden"
				} else {
					var classHidden = ""
				}

				return '<div class="create '+classHidden+'">Agregar <strong>'+query.input+'</strong>…</div>';
			}
		}
	})



	// Envio de creacion/edicion de clientes
	var clientForm = $("#kt_wizard_client #client-form")
	clientForm.on("click", ".action-submit", function(e){
		const disabledText = getTranslationValue(config, [language, "clientForm_on_click_action_sumit"], "Enviando Información...")
		$(this).addClass("disabled").text(disabledText);
		clientForm.addClass("disabled")
		clientForm.submit();
	})
	/*************
		* FIN CREAR / EDITAR OFERTA
		*/
	
	$('#client-form').on("change", "input[type='checkbox'].overview-is-active", function () {
		var inputContent = $(this).parent().parent().find('input.overview-content');
		if ($(this).is(':checked')) {
			inputContent.removeAttr('disabled');
			inputContent.removeClass('optional disabled');
		} else {
			inputContent.val('');
			inputContent.attr('disabled', true);
			inputContent.addClass('optional disabled');
		}
	})

	$('#client-form').on("change", "input[type='checkbox'].overview-is-active", function () {
		var inputContent = $(this).parent().parent().find('input.overview-content');
		if ($(this).is(':checked')) {
			inputContent.removeAttr('disabled');
			inputContent.removeClass('optional disabled');
		} else {
			inputContent.val('');
			inputContent.attr('disabled', true);
			inputContent.addClass('optional disabled');
		}
	});
	
	function getCRMClientsByCountryID(countryID){
		const AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
	
		// Consulta ajax
		$.ajax({
			type: "GET",
			url: "/admin/clients/get_crm_clients",
			dataType: 'json',
			data: {
					country_id: countryID,
					authenticity_token: AUTH_TOKEN
			}
		}).done(function(response, textStatus, jqXHR) {
			// Quita el cargando
			KTApp.unblockPage();
			renderCRMClients(response["data"]);
			$("#cont_client_name").removeClass("disabled");
	
		}).fail(function(jqXHR, textStatus, errorThrown) {
			// Quita el cargando
			KTApp.unblockPage();
			// Muestra alerta indicando que hay un error
			Swal.fire({
					text: getTranslationValue(config, [language, "topTable", "fail_Swalfire_text"], 'Lo sentimos!, Hubo un problema y no se pudo obtener los clientes. Por favor inténtalo mas tarde.'),
					icon: "error",
					buttonsStyling: false,
					confirmButtonText: getTranslationValue(config, [language, "topTable", "fail_Swalfire_confirmButtonText"], 'Aceptar'),
					customClass: {
							confirmButton: "btn btn-fj-purple"
					}
			});
		});
	}
	
	function getCRMCompanyByClient(clientID){
		const AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
	
		// Consulta ajax
		$.ajax({
			type: "GET",
			url: "/admin/clients/get_crm_company",
			dataType: 'json',
			data: {
					client_id: clientID,
					authenticity_token: AUTH_TOKEN
			}
		}).done(function(response, textStatus, jqXHR) {
			// Quita el cargando
			KTApp.unblockPage();

			if (response["data"] == null) {
				$("#cont_company").addClass("disabled");
			}

			renderCRMCompany(response["data"]);
	
		}).fail(function(jqXHR, textStatus, errorThrown) {
			// Quita el cargando
			KTApp.unblockPage();
			// Muestra alerta indicando que hay un error
			Swal.fire({
					text: getTranslationValue(config, [language, "topTable", "fail_Swalfire_text"], 'Lo sentimos!, Hubo un problema y no se pudo obtener la compañia. Por favor inténtalo mas tarde.'),
					icon: "error",
					buttonsStyling: false,
					confirmButtonText: getTranslationValue(config, [language, "topTable", "fail_Swalfire_confirmButtonText"], 'Aceptar'),
					customClass: {
							confirmButton: "btn btn-fj-purple"
					}
			});
		});
	}

	function getCRMCompanies(){
		const AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
	
		// Consulta ajax
		$.ajax({
			type: "GET",
			url: "/admin/clients/get_crm_all_companies",
			dataType: 'json',
			data: {
					authenticity_token: AUTH_TOKEN
			}
		}).done(function(response, textStatus, jqXHR) {
			// Quita el cargando
			KTApp.unblockPage();
			renderCRMCompanies(response["data"]);
	
		}).fail(function(jqXHR, textStatus, errorThrown) {
			// Quita el cargando
			KTApp.unblockPage();
			// Muestra alerta indicando que hay un error
			Swal.fire({
					text: getTranslationValue(config, [language, "topTable", "fail_Swalfire_text"], 'Lo sentimos!, Hubo un problema y no se pudo obtener el listado de compañias. Por favor inténtalo mas tarde.'),
					icon: "error",
					buttonsStyling: false,
					confirmButtonText: getTranslationValue(config, [language, "topTable", "fail_Swalfire_confirmButtonText"], 'Aceptar'),
					customClass: {
							confirmButton: "btn btn-fj-purple"
					}
			});
		});
	}
	
	function renderCRMClients(clients){
		clearSelectize(clientName)

		var selectize = clientName[0].selectize;
		clients.forEach(function(client){
			selectize.addOption({value: client.id, text: client.client_name});
		});

		selectize.settings.create = true;
	}
	
	function renderCRMCompany(company){
		clearSelectize(clientCompany)
		
		var selectize = clientCompany[0].selectize;

		if (company) {
			var newOption = { value: company.id, text: company.company_name };
			selectize.addOption(newOption);
			selectize.setValue(newOption.value);
		}

		selectize.settings.create = true;
	}

	function renderCRMCompanies(companies){
		clearSelectize(clientCompany)

		var selectize = clientCompany[0].selectize;
	
		companies.forEach(function(company){
			selectize.addOption({value: company.id, text: company.company_name});
		});
	
		selectize.settings.create = true;

		$("#cont_company").removeClass("disabled");
	}

	function clearSelectize(selectize){
		selectize[0].selectize.clear();
		selectize[0].selectize.clearOptions();
		selectize[0].selectize.refreshItems()
		selectize[0].selectize.refreshOptions();
		selectize.parent().find(".selectize-control .selectize-dropdown .selectize-dropdown-content").html("");
	}
});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
	
	let currentTranslation;
	let firstIteration = true;
	
	for (let key of keys) {

		if (firstIteration) {

			if (config[key]) {
				currentTranslation = config[key];
				firstIteration = false;
			} else {
				firstIteration = false;
				return defaultValue;
			}
		} else {
			
			if (currentTranslation[key]) {
				currentTranslation = currentTranslation[key];
			} else {
				return defaultValue;
			}
		}
	}

	return currentTranslation;
}